import React, { Component } from 'react'
import axios from 'axios'
import Config from '../../../commons/config/Config.js'
import InstanciaBasic from './InstanciaBasic.js'
import Dialog from '../../../commons/dialog/Dialog.js'
import { filtrarAdjuntosPorTipo } from '../helpers.js'

const configAxios = {
	headers: {
		'Authorization-Token': localStorage.getItem("token")
	}
};


class InstanciaBasicConAdjunto extends InstanciaBasic {
	constructor(props) {
		super(props);
		this.props = props;
		this.handleInputChange = this.handleInputChange.bind(this);
		this.handleChangeAndUpdateFather = this.handleChangeAndUpdateFather.bind(this);
		this.handleOpenAdjunto = this.handleOpenAdjunto.bind(this);
		this.castValue = this.castValue.bind(this);
		this.componentDidMount = this.componentDidMount.bind(this);
		this.componentDidUpdate = this.componentDidUpdate.bind(this);
		this.getAdjuntosExistentesIds = this.getAdjuntosExistentesIds.bind(this);
		this.mostrarAdjuntos = this.mostrarAdjuntos.bind(this);
		// VEC-3783 (review): identifica cada llamada a mostrarAdjuntos() para poder
		// descartar una respuesta vieja (ej. la carga del adjunto histórico) que
		// resuelve después de una más nueva (ej. la del archivo recién subido).
		this.ultimaCargaId = 0;
		this.state = {
			adjunto: null,
			adjunto_url: null,
			adjuntoArray: [],
			adjuntoUrlArray: [],
		}
	}

	castValue(value) {
		// VEC-3783 (review): typeof null === 'object', así que sin este chequeo un
		// valor null (campo vacío) se devolvía tal cual y rompía el .length de más abajo.
		if (value === null || typeof(value) !== 'object')
			return []
		else
			return value
	}

	// VEC-3783: adjunto_id/documento_id son pura escritura (adjuntos NUEVOS a subir).
	// Los adjuntos ya guardados viven en atributo.adjuntos (relación real que manda el
	// backend, mezclada por tipo) y no llegan nunca en adjunto_id/documento_id.
	getAdjuntosExistentesIds() {
		let esImagen = this.valueKey === 'adjunto_id'
		return filtrarAdjuntosPorTipo(this.props.atributo && this.props.atributo.adjuntos, esImagen)
			.map(adjunto => adjunto.adjunto_id)
	}

	componentDidMount() {
		let valorNuevo = this.castValue(this.props.atributo[this.valueKey])
		if (valorNuevo.length === 0) {
			let idsExistentes = this.getAdjuntosExistentesIds()
			if (idsExistentes.length > 0) {
				this.mostrarAdjuntos(idsExistentes)
				return
			}
		}
		this.handleChangeAndUpdateFather(valorNuevo)
	}

	componentDidUpdate(prevProps) {
		// VEC-3783 (review): comparar solo el campo de escritura no alcanza — si se
		// reusa esta instancia para otro atributo/relación (ej. cambio de tipo de
		// formulario) y ambos tienen adjunto_id/documento_id undefined, no se detecta
		// el cambio y quedan pegadas las miniaturas del atributo anterior.
		let cambioValorEscritura = prevProps.atributo[this.valueKey] !== this.props.atributo[this.valueKey]
		let cambioAdjuntosExistentes = prevProps.atributo.adjuntos !== this.props.atributo.adjuntos
		if (cambioValorEscritura || cambioAdjuntosExistentes) {
			this.componentDidMount()
		}
	}

	handleInputChange(event, intl = null) {
		// El input debe tener el atributo name para que funcione
		
		let files = event.target.files
		let idArray = [];
		let count = 0;

		for (let i = 0; i < files.length; i++) {
			let file = files[i]
			// 20971520
			if(file.size > 20971520 && intl !== null){
				Dialog.alert(intl, {
					title: intl.formatMessage({ id: 'instanciaBasicConAdjunto.error.el_archivo_es_demasiado_grande', defaultMessage: 'No se pudo subir el archivo. El mismo supera el tamaño máximo de 20 MB' }),
				});
				event.target.value = '';
			 } else if (file.size > 20971520) {
				console.log('No se pudo subir el archivo. El mismo supera el tamaño máximo de 20 MB');
			 } else {
				let fd = new FormData();
				fd.append("file", file);
				axios.post(Config.get('apiUrlBase') + '/adjuntos', fd, configAxios).then(response => {
					// this.handleChangeAndUpdateFather(response.data.id)
					idArray.push(response.data.id);
					count++
					if (count === files.length) {
						this.handleChangeAndUpdateFather(idArray, true)
					}
				})
			 }
		}
	}

	// Trae y pinta los thumbnails/urls de una lista de ids de adjunto (nuevos o existentes),
	// sin tocar el payload de escritura (adjunto_id/documento_id).
	mostrarAdjuntos(ids) {
		// VEC-3783 (review): si esta carga queda vieja (una más nueva empezó después,
		// ej. el usuario reemplazó el archivo mientras la carga del histórico todavía
		// estaba en vuelo), no debe pisar el estado con datos desactualizados.
		let idCarga = ++this.ultimaCargaId;
		let config = Object.assign({}, configAxios, { responseType: 'blob' });
		let count = 0;
		let adjArr = [];
		let adjUrlArr = [];
		ids.forEach((id, i) => {
			Promise.all([
				axios.get(Config.get('apiUrlBase') + '/adjuntos/' + id, configAxios),
				axios.get(Config.get('apiUrlBase') + '/adjuntos/files/' + id, config)
			]).then((data) => {
				adjArr.push(data[0].data);
				let fileUrl = URL.createObjectURL(data[1].data);
				adjUrlArr.push(fileUrl)
				count++;
				if (count === ids.length && idCarga === this.ultimaCargaId) {
					this.setState({ adjuntoArray: adjArr, adjuntoUrlArray: adjUrlArr })
				}
			}).catch(e => console.log(e))
		})
	}

	handleChangeAndUpdateFather(adjunto_id) {
		if((this.props.atributo && this.props.atributo.adjuntoUrlArray) || (this.props.atributo && this.props.atributo.adjuntoArray)){
			this.setState({ adjuntoArray: this.props.atributo.adjuntoArray, adjuntoUrlArray: this.props.atributo.adjuntoUrlArray })
		}else{
			if (adjunto_id && adjunto_id.length > 0) {
				this.props.handleChange(this.valueKey, adjunto_id)
				this.mostrarAdjuntos(adjunto_id)
			}
			else {
				this.setState({
					adjuntoArray: [],
					adjuntoUrlArray: []
				}, () => {
					this.props.handleChange(this.valueKey, []);
				});
			}
		}
	}

	handleOpenAdjunto(e, url) {
		window.open(url)
		e.preventDefault()
	}

	render() {
		return false
	}
}

export default InstanciaBasicConAdjunto;
